import { Box } from "@mui/material"
import { Trans } from "react-i18next"
import ProfileHeader from "../../../../components/ProfileHeader"
import IconButton from '@mui/material/IconButton';
import { Form, Formik } from "formik";
import Fab from '@mui/material/Fab';
import SaveIcon from '@mui/icons-material/Save';
import OutlinedTextField from "../../../../components/formFields/OutlinedTextField";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import domainInitialValues from "./domainInitialValues";
import domainValidationSchema from "./domainValidationSchema";
import { NotFoundUnitDialog } from "../../searchVehicles/notFoundUnitDialog";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  handleSubmit: any,
  dialogOpen: boolean,
  setDialogOpen: any,
  handleGoBack: any
}

export default (props: Props) => {
  const navigate = useNavigate()
  useEffect(() => {
    if (!document.body.classList.contains("grey-background")) {
      document.body.classList.add("grey-background");
    }
  }, []);

  return (
    <Box>
      <Formik
        initialValues={domainInitialValues}
        onSubmit={props.handleSubmit}
        validationSchema={domainValidationSchema}
        isInitialValid={false}
      >
        {({ isSubmitting, isValid }) => (
          <Form id="login">
            <ProfileHeader/>
            <Box className="create-maintenance-title"><Trans i18nKey={`screens.createMaintenance.title`}/></Box>
            <Box className="create-maintenance-card">
              <Box className="create-maintenance-description"><Trans i18nKey={`screens.createMaintenance.description`}/></Box>
              <OutlinedTextField
                label={`screens.createMaintenance.domain`}
                name="domain"
                autoComplete="domain"
                fullWidth={true}
                i18n
              />
            </Box>
            <Box className="bottom-nav">
              <IconButton className="bottom-nav-text-icon" onClick={props.handleGoBack}>
                <ArrowBackIcon />
              </IconButton>
              <Box sx={{flexGrow: "1"}}/>
              <Fab className="bottom-nav-text-fab" variant="extended" disabled={!isValid || isSubmitting} type="submit">
                <Trans i18nKey={`screens.createMaintenance.nextButton`}></Trans>
                <SaveIcon/>
              </Fab>
            </Box>
          </Form>
        )}
      </Formik>
      <NotFoundUnitDialog open={props.dialogOpen} handleClose={() => props.setDialogOpen(false)} />
    </Box>
  )
}